import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { t } from "../../i18n";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import styled from "@emotion/styled";

// Alt çizgi ile çevrelenmiş kelimeleri link haline getiren fonksiyon
const parseTextWithLinks = (text: string, onLinkClick: () => void) => {
  const parts = text.split(/(_[^_]+_)/);

  return parts.map((part, index) => {
    if (part.startsWith("_") && part.endsWith("_")) {
      // Alt çizgileri kaldır ve link haline getir
      const linkText = part.slice(1, -1);
      return (
        <a
          key={index}
          href="#"
          className="text-blue-400 hover:text-blue-300 underline cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            onLinkClick();
          }}
        >
          {linkText}
        </a>
      );
    }
    return part;
  });
};

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [pdfModalVisible, setPdfModalVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookieAccepted");
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieAccepted", "true");
    setVisible(false);
  };

  const handlePdfLinkClick = () => {
    setPdfModalVisible(true);
  };

  return (
    <>
      <StyledDialog
        visible={visible}
        onHide={() => setVisible(false)}
        style={{
          width: "90vw",
          maxWidth: "500px",
          margin: "0 auto",
        }}
        modal={true}
        closable={false}
        draggable={false}
        resizable={false}
        className="cookie-dialog"
      >
        <div className="flex flex-col gap-3 text-center p-4">
          <p className="m-0 text-sm md:text-base leading-relaxed">{parseTextWithLinks(t("cookieBanner.text"), handlePdfLinkClick)}</p>
          <div className="flex justify-center w-full mt-4">
            <button
              onClick={handleAccept}
              className="p-button-success bg-primaryGreen w-full md:w-32 text-white py-3 md:py-2 px-6 rounded-md text-sm md:text-base font-medium hover:bg-green-600 transition-colors duration-200"
            >
              {t("cookieBanner.accept")}
            </button>
          </div>
        </div>
      </StyledDialog>

      {/* PDF Modal */}
      <StyledDialog
        visible={pdfModalVisible}
        onHide={() => setPdfModalVisible(false)}
        style={{
          width: "95vw",
          height: "95vh",
          maxWidth: "1200px",
          maxHeight: "800px",
        }}
        modal={true}
        closable={true}
        draggable={false}
        resizable={false}
        className="pdf-modal"
        header={t("cookieBanner.header")}
      >
        <div className="w-full h-full">
          <iframe src="/documents/web-Cerez-Politikasi-1.pdf" width="100%" height="100%" style={{ border: "none" }} title="Çerez Politikası" />
        </div>
      </StyledDialog>
    </>
  );
};

const StyledDialog = styled(Dialog)`
  .p-dialog-content {
    background-color: #212121;
    color: #fff;
    padding: 0;
  }

  .p-dialog-header {
    background-color: #212121;
    color: #fff;
  }

  &.pdf-modal .p-dialog-content {
    background-color: #fff;
    color: #000;
    padding: 0;
  }

  &.pdf-modal .p-dialog-header {
    background-color: #f8f9fa;
    color: #000;
    border-bottom: 1px solid #e9ecef;
    padding: 1rem 1.5rem;
  }

  &.pdf-modal .p-dialog-header .p-dialog-title {
    font-weight: 600;
    font-size: 1.1rem;
  }

  /* Mobile optimizasyonları */
  @media (max-width: 768px) {
    .p-dialog {
      margin: 1rem;
    }

    .p-dialog-content {
      padding: 1rem;
    }

    &.pdf-modal .p-dialog-header {
      padding: 0.75rem 1rem;
    }

    &.pdf-modal .p-dialog-header .p-dialog-title {
      font-size: 1rem;
    }
  }

  @media (max-width: 480px) {
    .p-dialog {
      margin: 0.5rem;
    }

    .p-dialog-content {
      padding: 0.75rem;
    }
  }
`;

export default CookieBanner;
